import React, { useState, useEffect } from 'react';

const Hero = () => {
  const [bgClass, setBgClass] = useState('bg-hero-mobile');

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setBgClass('bg-hero-desktop');
      } else {
        setBgClass('bg-hero-mobile');
      }
    };

    handleResize(); // Set initial background
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div
      className={`landing relative w-full bg-fixed bg-no-repeat ${bgClass}`}
      style={{ backgroundSize: '100% 100%' }}
    >
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-white text-center px-4"> 
      </div>
    </div>
  );
};

export default Hero;
